import { render, staticRenderFns } from "./accordian.vue?vue&type=template&id=f38bf700&scoped=true&"
import script from "./accordian.vue?vue&type=script&lang=ts&"
export * from "./accordian.vue?vue&type=script&lang=ts&"
import style0 from "./accordian.vue?vue&type=style&index=0&id=f38bf700&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38bf700",
  null
  
)

export default component.exports